const getAlertTextKey = (
  payload: { [index: string]: string },
  adtAmount: number,
  infAmount: number,
) => {
  const [value] = Object.values(payload);

  if (payload.inf === 'max' && adtAmount === infAmount) {
    return 'main.cabinClass.rules.oneAdultPerInfant';
  }
  if (payload.adt === 'min') {
    return 'main.cabinClass.rules.minOneAdult';
  }
  if (payload.yth === 'min') {
    return 'main.cabinClass.rules.minOnePassenger';
  }
  if (value === 'max') {
    return 'main.cabinClass.rules.maxAmount';
  }

  return '';
};

export const passengersClassesLib = {
  getAlertTextKey,
};
